<template lang="pug">
modal#edit-webhook-modal(
  :cancel-action='openDeleteWebhookModal'
  :close='onCloseModal'
  :close-button-label='$t("modal.editWebhook.deleteButtonLabel")'
  :process-button-label='$t("modal.editWebhook.processButtonLabel")'
  :title='$t("modal.editWebhook.title")'
  @closed='onCloseModal'
  @process='submit'
  ref='modal'
)
  ValidationObserver(ref='form')
    form.form(@submit.prevent='submit')
      .row
        .col-12
          ValidationProvider(
            :name='$t("modal.editWebhook.urlLabel")'
            rules='required|url'
            v-slot='{ errors }'
          )
            .form-group
              label(for='email') {{ $t('modal.editWebhook.urlLabel') }}*
              .form-control-icon
                icon(name='users')
                input#email.form-control(
                  :class='{ "is-invalid": errors.length }'
                  :placeholder='$t("modal.editWebhook.urlPlaceholder")'
                  type='text'
                  v-model='url'
                )
              small.text.text-danger {{ errors[0] }}
  delete-developer-webhook-modal#delete-developer-webhook-modal(
    :uuid='uuid'
    @refresh='refresh'
    ref='deleteDeveloperWebhookModal'
  )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import WebhookService from '@/services/WebhooksService';
import alert from '@/modules/account/common/alert';
import DeleteDeveloperWebhookModal from '@/modules/account/components/organisms/modals/DeleteDeveloperWebhookModal.vue';
export default {
  name: 'EditWebhookModal',
  props: {
    uuid: [String],
    initialUrl: [String],
  },
  components: {
    DeleteDeveloperWebhookModal,
    Modal,
    Icon,
  },
  data() {
    return {
      url: '',
    };
  },
  watch: {
    initialUrl: {
      immediate: true,
      handler(newValue) {
        this.url = newValue || '';
      },
    },
  },
  methods: {
    onCloseModal() {
      this.url = '';
      this.$refs.form.reset();
      this.$refs.modal.close();
    },
    refresh() {
      this.$emit('refresh');
      this.onCloseModal();
    },
    openDeleteWebhookModal() {
      this.$refs.deleteDeveloperWebhookModal.$refs.modal.open();
    },
    submit() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.$loading(true);
        const pattern = /^((http|https|ftp):\/\/)/;
        if (!pattern.test(this.url)) {
          this.url = `http://${this.url}`;
        }
        WebhookService.update(this.uuid, {
          url: this.url,
        })
          .then(() => {
            this.$refs.modal.close();
            alert.fireAlert(this.$t('modal.editWebhook.successMessage'), {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            });
            this.$emit('refresh');
          })
          .finally(() => {
            this.$loading(false);
          });
      });
    },
  },
  computed: {},
};
</script>

<style scoped lang="stylus">
#edit-webhook-modal
  z-index: 1060;
  ::v-deep .modal-footer .d-flex
    justify-content space-between !important
    width 100%
  ::v-deep .modal-footer .btn-secondary
    white-space: nowrap !important;
    background-color: transparent !important;
    border-color: #19665b !important;
    color: #19665b !important;
    &:hover
      border-color: #19665b !important;
      color: #212529 !important;
</style>
